/**
 * Workspace roles. A workspace holds both the agency team and the client team;
 * the role decides which side a member is on and what they may do.
 * Permissions per role live in @onadssuper/auth (server) and are mirrored to
 * clients only to hide UI the server would reject anyway.
 */
export const AGENCY_ROLES = ["agency_owner", "agency_admin", "strategist", "publisher"] as const;
export const CLIENT_ROLES = ["client_owner", "client_reviewer"] as const;
export const WORKSPACE_ROLES = [...AGENCY_ROLES, ...CLIENT_ROLES] as const;

export type AgencyRole = (typeof AGENCY_ROLES)[number];
export type ClientRole = (typeof CLIENT_ROLES)[number];
export type WorkspaceRole = (typeof WORKSPACE_ROLES)[number];

export const ROLE_LABELS: Record<WorkspaceRole, string> = {
  agency_owner: "Agency owner",
  agency_admin: "Agency admin",
  strategist: "Strategist / creator",
  publisher: "Publisher",
  client_owner: "Client owner / approver",
  client_reviewer: "Client reviewer / analyst",
};

export const isAgencyRole = (role: WorkspaceRole): role is AgencyRole =>
  (AGENCY_ROLES as readonly string[]).includes(role);
